import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { ParcellaStragiudizialeForm } from '../../../form/parcelle/stragiudiziali/parcella-stragiudiziale-form';


import { SezioneParcelleStragiudizialiResponse } from '../../../models/dto/sezione-parcelle-stragiudiziali-response';
import { ParcellaStragiudiziale } from '../../../models/parcella-stragiudiziale';

import { SezioneParcelleStragiudiziali } from '../../../models/sezioni/sezione-parcelle-stragiudiziali';

@Component({
    selector: 'div [parcella-stragiudiziale-form-edit]',
  templateUrl: '../../../form/parcelle/stragiudiziali/parcella-stragiudiziale-form.html'
})

export class ParcelleStragiudizialiEditComponent extends ParcellaStragiudizialeForm {
  sezione: SezioneParcelleStragiudiziali;
  urlUpdate: string;
  urlReadSezioneLegali: string;
  urlReadSezioneEconomica: string;
  urlGetScaglioni: string;
  tipoFascicolo: any;
  tipoPratica: any;
  idFascicolo: string;

  @Output() onReturn: EventEmitter<SezioneParcelleStragiudiziali> = new EventEmitter<SezioneParcelleStragiudiziali>();

  constructor(@Inject(OperationsService) operationService, @Inject(FormBuilder) campiForm, @Inject(HelpersService) helpers: HelpersService) {
        super(operationService, campiForm, helpers);
  }

  ngOnInit() {
    this.setTitle('Modifica Parcella');
    this.isInserimento(false);
  }

  getParcellaStragiudiziale() {
    return this.parcellaStragiudiziale;
  }

  getUrlReadSezioneLegali() {
    return this.urlReadSezioneLegali;
  }

  getUrlReadSezioneEconomica() {
    return this.urlReadSezioneEconomica;
  }

  getUrlGetScaglioni() {
    return this.urlGetScaglioni;
  }

  getTipoFascicolo(): any {
    return this.tipoFascicolo;
  }

  getTipoPratica(): any {
    return this.tipoPratica;
  }

  getIdFascicolo() {
    return this.idFascicolo;
  }

  getRequest(request: ParcellaStragiudiziale) {
    this.operationService.updateParcellaStragiudiziale(this.urlUpdate, request, this.sezione.id).subscribe((response: any) => this.datiParcellaStragiudiziale(response));
  }

  datiParcellaStragiudiziale(response: SezioneParcelleStragiudizialiResponse) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }

  inizializza(sezione: SezioneParcelleStragiudiziali,
              parcellaStragiudiziale: ParcellaStragiudiziale,
              idSezioneLegali: string,
              idSezioneEconomica: string,
              urlUpdate: string,
              urlReadSezioneLegali: string,
              urlReadSezioneEconomica: string,
              urlGetScaglioni: string,
              tipoFascicolo: any,
              tipoPratica: number, idFascicolo: string) {
    this.parcellaStragiudiziale = parcellaStragiudiziale;
    this.sezione = sezione;
    this.urlUpdate = urlUpdate;
    this.urlReadSezioneLegali = urlReadSezioneLegali;
    this.urlReadSezioneEconomica = urlReadSezioneEconomica;
    this.urlGetScaglioni = urlGetScaglioni;
    this.tipoPratica = tipoPratica;
    this.tipoFascicolo = tipoFascicolo;
    this.idFascicolo = idFascicolo;
    this.readSezioneLegali(idSezioneLegali);
    this.readSezioneEconomica(idSezioneEconomica);
    this.createForm();
    this.populateSelect();
  }

}
